import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import PermissionList from "RolesAndPermissions/commonComponents/PermissionList";
export default store => ({
  path: "class-roles",
  component: withAsyncRouteLoading(() =>
    Promise.all([
      import(/* webpackChunkName: "roles-and-permissions" */ "./components"),
    ]).then(([importedModule0]) => {
      const component = importedModule0.default;
      return component;
    })
  ),
  childRoutes: [PermissionList(store)],
});
